import React, { useMemo, useState } from "react";
import CheatsheetBlockEditorPanel from "./CheatsheetBlockEditorPanel";
import CheatsheetBlockList from "./CheatsheetBlockList";
import { createCheatsheetBlock } from "./cheatsheetBlockFactory";
import { moveItem } from "../../../../../utils/reorder";

export default function CheatsheetEditor({
                                             value,
                                             onChange,
                                         }) {
    const content = useMemo(() => ({
        version: 1,
        blocks: [],
        ...(value || {}),
    }), [value]);

    const [selectedBlockId, setSelectedBlockId] = useState(null);

    const updateBlocks = (blocks) => {
        onChange({
            ...content,
            blocks,
        });
    };

    const handleAddBlock = (type) => {
        const block = createCheatsheetBlock(type);

        if (!block) return;

        const blocks = [...content.blocks, block];

        updateBlocks(blocks);
        setSelectedBlockId(block.id);
    };

    const handleDeleteBlock = (id) => {
        const blocks = content.blocks.filter(
            block => block.id !== id
        );

        updateBlocks(blocks);

        if (selectedBlockId === id) {
            setSelectedBlockId(null);
        }
    };

    const handleMoveBlock = (from, to) => {
        updateBlocks(
            moveItem(content.blocks, from, to)
        );
    };

    const handleUpdateBlock = (updatedBlock) => {
        updateBlocks(
            content.blocks.map(block =>
                block.id === updatedBlock.id
                    ? updatedBlock
                    : block
            )
        );
    };

    return (
        <div className="space-y-5">

            <CheatsheetBlockEditorPanel
                onAddBlock={handleAddBlock}
            />

            <CheatsheetBlockList
                blocks={content.blocks}
                selectedBlockId={selectedBlockId}
                onSelect={setSelectedBlockId}
                onDelete={handleDeleteBlock}
                onMove={handleMoveBlock}
                onUpdate={handleUpdateBlock}
            />

        </div>
    );
}